<template>
  <div class="d-flex" v-if="!isEmpty(sorts)">
    <span class="t-sm t-600 pr-1 text-nowrap">Sort by:</span>
    <dropdown
      placement="bottom-end"
      noPadding
    >
      <template #button>
        <span class="t-sm t-blue t-600 cursor-pointer d-flex align-items-center"><template v-if="activeSort.label">{{ activeSort.label }}</template><template v-else>{{ activeSort.name | capitalize | humanize }}</template> <i class="t-xs fa fa-chevron-down t-secondary ml-1" /></span>
      </template>
      <a
        v-for="(sort, index) in sorts" :key="index"
        href="#" @click.prevent="handleSort(sort)" class="bg-grey-hover d-block py-2 px-3 t-primary d-flex"
      >
        <i class="fa fa-check t-secondary mr-2 mt-1" :class="{ 'invisible': !sort.active }" />
        <div>
          <div class="d-flex">
            <span class="t-600"><template v-if="sort.label">{{ sort.label }}</template><template v-else>{{ sort.name | capitalize | humanize }}</template>
              <i class="fa fa-lock t-blue ml-2 semi-transparent" v-if="sort.locked" />
            </span>
            <span v-if="sort.new" class="t-yellow t-700 t-xs pt-1 ml-2">NEW</span>
          </div>
          <span v-if="sort.description" class="t-400 t-sm t-secondary d-block">{{ sort.description }}</span>
        </div>
      </a>
    </dropdown>
  </div>
</template>

<script>
import MPService from '@/services/mixpanel'

import Dropdown from '@/components/shared/form/Dropdown'

export default {
  name: 'searchSort',
  components: {
    Dropdown
  },
  props: {
    sorts: {
      type: Array,
      required: true
    }
  },
  computed: {
    activeSort () {
      return this.sorts.find(sort => sort.active)
    }
  },
  methods: {
    handleSort (sort) {
      if (sort.locked) {
        this.$can.notAllowed()
        return
      }
      MPService.trackEvent('search_sort_changed', { type: sort.name })
      this.$emit('sortHandled', sort.name)
    }
  }
}
</script>
